
"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { AlertTriangle, Clock, EyeSlash, ShieldAlert } from "lucide-react";
import Link from "next/link";

interface SuspendedSitePageProps {
  reason: string | null;
}

export function SuspendedSitePage({ reason }: SuspendedSitePageProps) {
  let title = "Site Temporariamente Indisponível";
  let message = "Este site não está acessível no momento. Por favor, tente novamente mais tarde.";

  switch (reason) {
    case 'trial_expired':
      title = "Período de Teste Expirado";
      message = "O período de teste gratuito para este site terminou.";
      break;
    case 'subscription_expired':
      title = "Assinatura Expirada";
      message = "A assinatura para este site expirou.";
      break;
    case 'view_limit_exceeded':
      title = "Limite de Visualizações Atingido";
      message = "Este site atingiu o limite de visualizações para o plano atual.";
      break;
    case 'suspended_by_admin':
      title = "Site Suspenso";
      message = "Este site foi suspenso por um administrador.";
      break;
    case 'permission_denied':
        title = "Acesso Negado";
        message = "Você não tem permissão para visualizar esta página de preview.";
        break;
    case 'suspended':
    default:
      // Mantém as mensagens padrão.
      break;
  }


  return (
    <div className="flex min-h-screen items-center justify-center bg-muted p-4">
      <Card className="w-full max-w-md text-center shadow-lg">
        <CardHeader>
          {reason === 'permission_denied' ? (
              <ShieldAlert className="mx-auto h-12 w-12 text-destructive" />
          ) : (
              <AlertTriangle className="mx-auto h-12 w-12 text-destructive" />
          )}
          <CardTitle className="mt-4 font-headline text-2xl">{title}</CardTitle>
          <CardDescription className="pt-2">{message}</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Se você é o proprietário deste site, acesse seu painel de controle para mais informações.
          </p>
        </CardContent>
        <CardFooter className="flex justify-center">
            <Button asChild>
                <Link href="/">Ir para o Painel</Link>
            </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
